export default __webpack_public_path__ + "locales/pt/Payments.json?hash=8f4616ebbe1789175156b820a284dd76";